import { Card, Divider, Stack, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { usePaymentReturn } from "./hooks/usePaymentReturn";

const PaymentReturn = ({setShowNav}) => {

    useEffect(() => {
        setShowNav(true);
    }, [])

    const {isSuccessful} = usePaymentReturn()

    return (
        <Stack direction="row" justifyContent="center" alignItems="center" padding={7}>
            <Card className={"detail-card"} sx={{padding:2}}>
                <Stack padding={1} direction={"column"} alignItems={"center"}>
                    {
                        isSuccessful && <Typography variant={'h4'} sx={{color:'#263238'}}>Votre paiement s'est bien passé</Typography>
                    }
                    {
                        !isSuccessful && <Typography variant={'h4'} sx={{color:'#263238'}}>Une erreur est survenue lors du payement</Typography>
                    }
                </Stack>
                <Divider />
                <Stack direction="column" justifyContent="center" alignItems="flex-start" padding={2}>
                    <button className={'validationButton'}>Revenir à l'accueil</button>
                </Stack>
            </Card>
        </Stack>
    )
}


export default PaymentReturn